let modalController;
let toastController;

const pendingModalActions = [];
const pendingToastActions = [];

function resolveToastPosition(toaster) {
  const positions = {
    'b-toaster-top-left': 'top-start',
    'b-toaster-top-center': 'top-center',
    'b-toaster-top-right': 'top-end',
    'b-toaster-top-full': 'top-center',
    'b-toaster-bottom-left': 'bottom-start',
    'b-toaster-bottom-center': 'bottom-center',
    'b-toaster-bottom-right': 'bottom-end',
    'b-toaster-bottom-full': 'bottom-center',
  };
  return positions[toaster] || 'top-end';
}

function runOrQueueModalAction(action) {
  if (modalController) {
    action(modalController);
    return;
  }
  pendingModalActions.push(action);
}

function runOrQueueToastAction(action) {
  if (toastController) {
    action(toastController);
    return;
  }
  pendingToastActions.push(action);
}

export function setBootstrapControllers(modal, toast) {
  modalController = modal;
  toastController = toast;

  while (pendingModalActions.length > 0) {
    const action = pendingModalActions.shift();
    action(modalController);
  }

  while (pendingToastActions.length > 0) {
    const action = pendingToastActions.shift();
    action(toastController);
  }
}

export const bvModal = {
  show(id) {
    runOrQueueModalAction((controller) => {
      if (id === undefined) {
        controller.show();
        return;
      }
      const modal = typeof controller.get === 'function' ? controller.get(id) : null;
      if (modal && typeof modal.show === 'function') {
        modal.show();
        return;
      }
      controller.show(id);
    });
  },

  hide(id) {
    runOrQueueModalAction((controller) => {
      if (id === undefined) {
        controller.hide();
        return;
      }
      const modal = typeof controller.get === 'function' ? controller.get(id) : null;
      if (modal && typeof modal.hide === 'function') {
        modal.hide();
        return;
      }
      controller.hide(undefined, id);
    });
  },
};

export const bvToast = {
  toast(message, options = {}) {
    runOrQueueToastAction((controller) => {
      const modelValue = options.noAutoHide ? true : (options.autoHideDelay || 3000);
      const toastData = {
        position: resolveToastPosition(options.toaster),
        modelValue,
        noCloseButton: options.noCloseButton,
        solid: options.solid,
        variant: options.variant,
      };

      if (typeof message === 'string') {
        toastData.body = message;
      } else {
        toastData.slots = {
          default: () => message,
        };
      }

      controller.create(toastData);
    });
  },
};
